import { render, staticRenderFns } from "./levelUpgrade.vue?vue&type=template&id=986077fc&scoped=true&"
import script from "./levelUpgrade.vue?vue&type=script&lang=js&"
export * from "./levelUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./levelUpgrade.vue?vue&type=style&index=0&id=986077fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986077fc",
  null
  
)

export default component.exports